// redux/slices/chatSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name:'Chats',
  chats: [],
  messages: [],
  currentChatId: null,
  isChatLoading: false,
  error: null,
};

const ChatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setCurrentChatId: (state, action) => {
      state.currentChatId = action.payload;
    },
    setIsChatLoading: (state, action) => {
      state.isChatLoading = action.payload;
    },
  },
});


export const { 
  setCurrentChatId,
  setIsChatLoading,
 } = ChatSlice.actions;
export default ChatSlice.reducer;

